import {
  AfterContentInit,
  AfterViewInit,
  Component,
  DoCheck,
  HostListener,
  OnChanges,
  OnInit,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CommonService } from "../../shared/common.service";
import { AuthService } from "../auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpResponse } from "@angular/common/http";
import { MatSnackBar } from "@angular/material";
import Swal from "sweetalert2";
import { ImageCroppedEvent } from "ngx-image-cropper";
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  windowWidth: any;
  choirId: any = "";
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.windowWidth = event.target.innerWidth;
    //  console.log(this.windowWidth,"333444")
  }

  isSpinnerVisible: boolean;
  imagee = "../../../assets/images/Rectangle.png";
  loginForm: FormGroup;
  userForm: FormGroup;
  formSubmitted: boolean = false;
  errorMsg: string = "Ok";
  headers = [];
  adminUser: boolean = true;
  clubUser: boolean = false;
  LoginFlag: boolean = true;
  ResetFlag: boolean = false;
  remember: boolean = false;
  Loginmessage: string = "";
  isLoading: boolean = false;
  resetForm: FormGroup;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
  };
  closeResult: string;
  private modalRef: NgbModalRef;
  // childArray = Array(1)
  //   .fill(null)
  //   .map(() => ({
  //     firstName: "",
  //     lastName: "",
  //     age: null,
  //     gender: "",
  //   }));
  currentChildIndex = 0;
  numberOfKids: number;
  fcmToken: any;
  emailPattern =
    /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

  constructor(
    private fb: FormBuilder,
    private authServices: AuthService,
    private commonService: CommonService,
    private router: Router,
    private _snackBar: MatSnackBar,
    private modalService: NgbModal,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.windowWidth = window.innerWidth;
    // console.log("1",this.windowWidth)
    this.initialiseForms();
    localStorage.clear();
    this.route.queryParams.subscribe((param) => {
      if (param["choirId"]) {
        this.choirId = param["choirId"];
        localStorage.setItem("choirId", this.choirId);
        // this.fetchProfile();
      }
    });
    // setTimeout(() => {
    //   debugger;
    //   this.fcmToken = localStorage.getItem("fcmToken");
    //   console.log(this.fcmToken, "fcm");
    // }, 1000);
  }

  ngAfterContentInit() {
    // console.log("cccccc")
  }

  initialiseForms() {
    this.loginForm = this.fb.group({
      email: ["", [Validators.required, Validators.pattern(this.emailPattern)]],
      password: ["", [Validators.required, Validators.minLength(8)]],
    });
    this.userForm = this.fb.group({
      firstName: ["", [Validators.required]],
      lastName: ["", [Validators.required]],
      profilePic: [""],

      // password: ["", [Validators.required, Validators.minLength(8)]],

      // gender: ["", [Validators.required]],
    });
    // this.ChildForm = this.fb.group({

    // })
  }

  onScroll(event: WheelEvent): void {
    event.preventDefault();
  }
  // numberOfKids: ["", [Validators.required]],
  // age: [Number, [Validators.required]],
  loginFN() {
    this.router.navigate(["main/dashboard"]);
  }
  userInfo: any;
  pendingBooking: any;
  login() {


    this.fcmToken = localStorage.getItem("fcmToken");
    this.formSubmitted = true;
    if (this.loginForm.valid) {
      let req = {
        email: this.loginForm.controls["email"].value.trim(),
        password: this.loginForm.controls["password"].value,
        // deviceToken: this.fcmToken,
      };
      this.isLoading = true;
      this.authServices.validateLogin(req).subscribe(
        (res: HttpResponse<any>) => {
          this.isLoading = false;
          if ((res["message"] = "Success")) {
            this.commonService.setStorage(
              "token",
              res.headers.get("Authorization")
            );
            localStorage.setItem(
              "userData",
              JSON.stringify(res.body["data"]["response"])
            );
            // console.log("userData",JSON.stringify(res.body['data']['response']))
            this.userInfo = res.body["data"]["response"];
            this.pendingBooking = this.userInfo?.isPendingBooking;
            console.log(this.pendingBooking, " this.pendingBooking");

            localStorage.setItem("activeIndex", "0");

            // if (this.userInfo?.isProfileBasic == true) {
              // if (this.choirId != "") {
              //   this.router.navigate(["main/choir-detail"], {
              //     queryParams: { id: this.choirId },
              //   });
              // } else {

              this.router.navigate(["main/home"]);
              //   }
            // } 
            // else {
            //   this.signInScreen = false;
            //   this.userDetailScreen = true;
            // }

            // if (res.body["data"]["response"]["isProfileDone"] == false) {
            //   this.router.navigate(["profile"], {
            //     queryParams: {
            //       id: res.body["data"]["response"]["isProfileDone"],
            //     },
            //   });
            //   return this._snackBar.open("Please complete profile!!", "", {
            //     duration: 3000,
            //     horizontalPosition: "right",
            //     verticalPosition: "top",
            //     panelClass: ["success"],
            //   });
            // } else {
            // //  this.router.navigate(["main/home"]);
            // }
          } else {
          }
        },
        (err) => {
          this.isLoading = false;
        }
      );
    }
  }
  onContinuetoDetail() {
    this.formSubmitted = true;
    let isValid = true;

    for (let child of this.childArray) {
      for (let key in child) {
        if (
          key !== "profilePic" &&
          (child[key] === null || child[key] === undefined || child[key] === "")
        ) {
          isValid = false;
          break;
        }
      }

      if (!isValid) {
        return this._snackBar.open(
          "Please enter all children's details !!",
          "",
          {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          }
        );
      }
    }

    if (!isValid) {
      console.error("Some fields are empty.");
    } else {
      // Proceed with your logic

      if (this.numberOfKids == 0 || !this.numberOfKids) {
        return this._snackBar.open("Please Select No. of kids ", "", {
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["failure"],
        });
      }
      // if (this.userForm.valid) {
      let req = this.userForm.value;

      req["profilePic"] = this.storeImage;
      req["numberOfKids"] = this.numberOfKids;
      req["kidsArray"] = this.childArray;

      // req["isProfileBasic"] = true;
      // req["profilePic"] =
      //   "https://s3.us-west-1.amazonaws.com/puffguyz/puffGuys/1723640184073_dummImage11.png";
      // this.isLoading = true;
      this.authServices.updateProfileApi(req).subscribe(
        (res: HttpResponse<any>) => {
          this.isLoading = false;
          if ((res["message"] = "Success")) {
            // console.log("userData",JSON.stringify(res.body['data']['response']))

            localStorage.setItem("activeIndex", "0");
            // if (this.choirId != "") {
            //   this.router.navigate(["main/choir-detail"], {
            //     queryParams: { id: this.choirId },
            //   });
            // } else {

            localStorage.setItem(
              "userData",
              JSON.stringify(res["data"]["response"])
            );
            this.router.navigate(["main/home"]);
            //  }
            //  this.router.navigate(["main/home"]);

            // if (res.body["data"]["response"]["isProfileDone"] == false) {
            //   this.router.navigate(["profile"], {
            //     queryParams: {
            //       id: res.body["data"]["response"]["isProfileDone"],
            //     },
            //   });
            //   return this._snackBar.open("Please complete profile!!", "", {
            //     duration: 3000,
            //     horizontalPosition: "right",
            //     verticalPosition: "top",
            //     panelClass: ["success"],
            //   });
            // } else {
            // //  this.router.navigate(["main/home"]);
            // }
          } else {
          }
        },
        (err) => {
          this.isLoading = false;
        }
      );
    }
  }
  show: boolean = false;
  password() {
    this.show = !this.show;
  }
  resetPassword() {
    this.formSubmitted = true;
    if (this.resetForm.valid) {
      let req = {
        email: this.resetForm.controls["userName"].value.trim(),
      };
      this.isLoading = true;
      this.authServices.resetPassword(req).subscribe(
        (res: HttpResponse<any>) => {
          this.isLoading = false;
          if ((res["message"] = "Success")) {
            this.navigatePassword();
            this._snackBar.open("Password sent to the registered Email!!", "", {
              duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["success"],
            });
          } else {
          }
        },
        (err) => {
          this.isLoading = false;
        }
      );
    }
  }
  navigatePassword() {
    this.LoginFlag = !this.LoginFlag;
    this.initialiseForms();
  }
  signInScreen: boolean = true;
  userDetailScreen2: boolean = false;
  userDetailScreen: boolean = false;
  LoginToNext() {
    this.signInScreen = false;
    this.userDetailScreen = true;
  }
  ContinueToNext() {
    this.signInScreen = false;
    this.userDetailScreen = false;
    this.userDetailScreen2 = true;
  }
  childArray: any[] = [];
  generateChildControls() {
    const numberOfChildren = this.numberOfKids;

    if (numberOfChildren >= 8) {
      return this._snackBar.open("No. of Kids Should not be more than 7", "", {
        duration: 3000,
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: ["failure"],
      });
    }

    this.childArray = Array(numberOfChildren)
      .fill(null)
      .map(() => ({
        firstName: "",
        lastName: "",
        age: null,
        gender: "",
        profilePic: "",
      }));
    this.currentChildIndex = 0;
    // const numberOfChildren = this.userForm.get("children").value || 0;
    // this.childArray = Array(numberOfChildren).fill(0);
  }

  get selectedChild() {
    return this.childArray[this.currentChildIndex];
  }
  hoveredIndex: any;
  onMouseEnter(index: number) {
    this.hoveredIndex = index;
  }

  onMouseLeave() {
    this.hoveredIndex = null;
  }

  selectChild(index: number) {
    this.currentChildIndex = index;
  }

  onContinue() {
    // Handle the final submission
    console.log("All Child Data:", this.childArray);
    // Add your logic to handle the final array
  }
  public profilePic: any;
  public imageChangedEvent: any = "";
  public imageChangedEvent1: any = "";
  public croppedImage: any = "";
  public isUploading: boolean = true;
  public indexNumber: any = {};
  public showAllImages = false;
  isLoading2: boolean = false;
  storeImage: any;
  save() {
    this.closeModal();
    const blob = this.b64toBlob(this.croppedImage);
    this.isLoading2 = true;
    this.imageChangedEvent = null;
    this.authServices.uploadImage(blob).subscribe(
      (res) => {
        this.isLoading2 = false;

        if (res["message"] === "Success") {
          this.isLoading2 = false;
          this.storeImage = res.data.url;
          this.userForm.value.profilePic = this.storeImage;

          console.log(this.userForm.value.profilePic, "profile pic");
        }
      },
      (err) => {
        this.isLoading2 = false;
      }
    );
  }
  kidImage: any;

  save2() {
    this.closeModal();
    const blob = this.b64toBlob(this.croppedImage);
    this.isLoading2 = true;
    this.imageChangedEvent = null;
    this.authServices.uploadImage(blob).subscribe(
      (res) => {
        this.isLoading2 = false;

        if (res["message"] === "Success") {
          this.isLoading2 = false;
          this.kidImage = res.data.url;

          this.childArray[this.currentChildIndex].profilePic = this.kidImage;
          // this.userForm.value.profilePic = this.storeImage;

          console.log(this.userForm.value.profilePic, "profile pic");
        }
      },
      (err) => {
        this.isLoading2 = false;
      }
    );
  }

  b64toBlob(dataURI) {
    var byteString = atob(dataURI.split(",")[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: "image/jpeg" });
  }

  fileChangeEvent(event: any, content: any, btn: any): void {
    this.isLoading = true;
    let file, img;

    if (
      (file = event.target.files[0]) &&
      (file.type === "image/png" || file.type === "image/jpeg")
    ) {
      img = new Image();
      this.imageChangedEvent = event;
      this.OpenModal(content, btn);
    } else {
      if (file) {
        Swal.fire({
          icon: "error",
          html: "Unsupported File Type. Only jpeg and png is allowed!",
        });
      } else {
        return;
      }
    }
    this.isLoading = false;
  }
  imageChangedEvent2: any;
  fileChangeEvent2(event: any, content: any, btn: any, i: any): void {
    this.isLoading = true;
    let file, img;

    if (
      (file = event.target.files[0]) &&
      (file.type === "image/png" || file.type === "image/jpeg")
    ) {
      img = new Image();
      this.imageChangedEvent2 = event;
      this.OpenModalKid(content, btn, i);
    } else {
      if (file) {
        Swal.fire({
          icon: "error",
          html: "Unsupported File Type. Only jpeg and png is allowed!",
        });
      } else {
        return;
      }
    }
    this.isLoading = false;
  }
  passwordVisible = false;

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }
  selectedFile: File;
  cancel(): void {
    this.selectedFile = null;
    this.croppedImage = null;
    this.imageChangedEvent = null;
    this.isUploading = false;
    setTimeout(() => {
      /** spinner ends after 1 seconds */
      this.isUploading = true;
    }, 1000);
  }
  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  name: any;
  imageUrl: any;

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    // console.log(this.croppedImage,'CropImage')
  }
  OpenModal(content, btn) {
    this.modelOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      size: "lg",
    };
    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  index: any;
  OpenModalKid(content, btn, i) {
    this.index = i;
    this.modelOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      size: "lg",
    };
    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  closeModal() {
    this.modalRef.close();
    // this.selectedActivity = [];
    // this.allSelectedActivities = [];
    // this.selectedActivities = []
    // this.allSelectedActivities = JSON.parse(localStorage.getItem('allactivity'));
    // this.selectedActivities = JSON.parse(localStorage.getItem('activityInput'));
  }

  // https://acc-dev.abrohn.com/

  backScreen() {
    // window.open("https://acc-dev.abrohn.com/", "_self");
    window.open("https://adventchildrenschoir.org/", "_self");
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}
